import React, { FC } from 'react'
import { Column } from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import { useTranslation } from 'react-i18next'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import IAWarehouseKPICell from './IAWarehouseKPICell'

export interface CellProps {
  column?: Column
  customClass?: any
}

const useStyles = makeStyles(theme => ({
  enhancedCellWrapper: {
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#eeeeee',
    borderBottom: '1px solid #ccc'
  },
  customBorder: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRight: '2px #ccc solid',
      right: 0,
      height: '50%',
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  },
  cell: {
    display: '-webkit-box',
    overflow: 'hidden',
    textAlign: 'center'
  }
}))

const IAWarehouseHeaderWithKPI: ({ headers }) => FC<CellProps> =
  ({ headers }) =>
  ({ column }) => {
    const { label, key, isStickyBorder } = column
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation()
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = useStyles({ isStickyBorder })

    return (
      <>
        {headers?.map(header => (
          <IAWarehouseKPICell value={'--'} />
        ))}
        <div
          className={classNames(
            classes.enhancedCellWrapper,
            'enhancedCellWrapperOverride',
            {
              [classes.customBorder]: !key,
              customBorderOverride: !key
            }
          )}
        >
          <span className={classes.cell}>
            <Typography variant={'subtitle2DarkGrey'}>
              {key ? t(`order.listview.colHeader.${key}`, label) : label}
            </Typography>
          </span>
        </div>
      </>
    )
  }

export default IAWarehouseHeaderWithKPI
